var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"color":"primary"},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})
}
var staticRenderFns = []

export { render, staticRenderFns }